$(document).on("turbolinks:load", () => {
    // 画面遷移時確認ダイアログ表示
    $("a#confirm_inquiry").on('click', function(event){
        event.preventDefault();

        var linkUrl = $(this).attr('href');
        var name = $(this).data('examination-name')

        var new_ele=document.createElement("div");
        var html = `<div class="modal js-modal">
                        <div class="modal__bg js-modal-close"></div>
                        <div class="modal__content">
                            <p>【確認】<br>${name}の問診票の画面へ進みます。<br>よろしければ「はい」を選択してください。</p>
                            <div class="footer-button--block">
                                <div id="ok" class="button button-primary">はい</div>
                                <div id="no" class="button button-primary">いいえ</div>
                            </div>
                        </div>
                    </div>`
        new_ele.innerHTML= html;
        document.body.appendChild(new_ele);

        $('.js-modal').fadeIn();

        $('#ok').on('click',function(){
            location.href = linkUrl;
            return false;
        });
    
        $('#no').on('click',function(){
            $.when(
                $('.js-modal').fadeOut()
            ).done(function(){ 
                $('.js-modal').parent().remove();
            });
            return false;
        });
    
    });
    
    // 未入力アラート
    $("#new_wny01_form, #new_wny02_form, #new_wny03_form, #new_wny04_form, #new_wny05_form").validationEngine({
        promptPosition: "topLeft",
        scrollOffset: 200
    });

    // 登録処理
    // 「登録して目次へ」ボタン押下時
    $('#inquiry-create-submit').on('click',function(){
        create_method(this, false)
    });
    // 「次へ」ボタン押下時
    $('#inquiry-create-next-submit').on('click',function(){
        create_method(this, true)
    });
    
    // 更新処理
    // 「登録して目次へ」ボタン押下時
    $('#inquiry-update-submit').on('click',function(){
        update_method(this, false, false)
    });
    // 「前へ」ボタン押下時
    $('#inquiry-update-back-submit').on('click',function(){
        update_method(this, true, false)
    });
    // 「次へ」ボタン押下時
    $('#inquiry-update-next-submit').on('click',function(){
        update_method(this, false, true)
    });

    // チェックボックス選択時の複数選択の上限制御
    $('input[type="checkbox"].upper_limit').click(function() {
        check_upper_limit(this);
    });

    // 画面遷移時の複数選択の上限制御
    var element = $('input[type="checkbox"].upper_limit:checked');
    $.each(element,function(){
        check_upper_limit(this);
    });

    // 問診票詳細画面遷移時にフォーム入力無効状態にする
    if ($('#interview-show').length){
        $('input').prop('disabled', true);
        $('textarea').prop('disabled', true);
    }

    // スクロール表示処理　（問診票登録、編集、詳細（閲覧専用）画面でのみ発火させる）
    if($("#interview-new").length != 0 || $("#interview-edit").length != 0 || $("#interview-show").length != 0){
        $('header').addClass('no_fixed');
        var interview_position = $(".headline-interview").offset().top;
        var interview_height = $(".headline-interview").outerHeight();
        $(window).on("scroll", function() {
            
            var scroll = $(window).scrollTop();
            if( interview_position < scroll ){
                $(".headline-interview").addClass('fixed');
                if($("#interview-new").length != 0 || $("#interview-edit").length != 0){
                    $(".headline-interview-text").css({'margin-top':(interview_height+10)+'px'});
                }
            } else {
                $(".headline-interview").removeClass('fixed');
                if($("#interview-new").length != 0 || $("#interview-edit").length != 0){
                    $(".headline-interview-text").css({'margin-top':'0'});
                }
            }
        });
    }


})

function create_method(el, to_next){
    var examination_cd = $(el).attr('data-examination-cd');
    document.getElementById('new_'+ examination_cd +'_form').action= "/"+ examination_cd +"_inquiries?to_next=" + to_next
}

function update_method(el, to_back, to_next){
    var examination_cd = $(el).attr('data-examination-cd');
    var inquiry_id = $(el).attr('data-id');

    document.getElementById('new_'+ examination_cd +'_form').action= "/"+ examination_cd +"_inquiries/" + inquiry_id + "?to_back=" + to_back + "&to_next="+ to_next ;

}

function check_upper_limit(el){
    var name = $(el).attr('name')
    var limit_num = $(el).data('limit');
    var checked_length = $('input[name="'+ name +'"]:checked').length;

    if (checked_length >= limit_num) {
        $('input[name="'+ name +'"]:not(:checked)').prop('disabled', true);
    } else {
        $('input[name="'+ name +'"]:not(:checked)').prop('disabled', false);
    }
}